module.exports = __webpack_public_path__ + "img/repair_request.58cfc6e8.svg";